import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: 'https://api.buddieshr.com',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// New webapp API (hosts /landing/demo-form, /landing/waitlist and /landing/leads).
const webappInstance = axios.create({
  baseURL: 'https://webapp-api.buddieshr.com',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const getPolicies = () =>
  instance.get(`/landing/open-policies/list`).then(({ data }) => data);

export const getRemoteJobs = () =>
  instance.get(`/landing/remote-jobs/list`).then(({ data }) => data);

export const postGetStartedForm = (payload) =>
  instance.post(`/landing/get-started-form`, payload);

export const postDemoForm = (payload) =>
  webappInstance.post(`/landing/demo-form`, payload);

// payload: { email, app, platform }
export const postWaitlist = (payload) =>
  webappInstance.post(`/landing/waitlist`, payload);

// payload: { email, location?, queryString?, gacid?, fbclid?, gclid? }
// Called server-side by /api/lead (Get started email modal).
export const postLead = (payload, { timeout } = {}) =>
  webappInstance.post(`/landing/leads`, payload, { timeout });

export const sendGoogleAdsId = (baseURL, params) => {
  const customInstance = axios.create({
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  return customInstance.post(`/slack/oauth/success`, params);
}